import Notifications from 'react-notification-system-redux';
import { adopted } from '../../../general/apiScenarios';
import { CHNode } from '../../../general/node';
import { logger } from '../../logger';
import { getNodeById, getSelectedNodesInAllFolders } from '../fileManager/selectors/selectors';
import * as removerActions from './actions';
import { Messages } from './model';
import { getBulkJobID, getSelectedCounts } from './selectors';
import { _select, ListenerApiLight, lm } from '../../listenerMiddleware';

export function removerRootListener() {
  lm.takeEvery(removerActions.deleteButtonClicked, async (_, lapi) => {
    const selected = _select(lapi, getSelectedNodesInAllFolders);
    const nodesById = _select(lapi, getNodeById);
    const bulkJobID = _select(lapi, getBulkJobID);
    if (bulkJobID === null) return;
    lapi.dispatch(removerActions.bulkJobStarted({ bulkJobID }));

    const results = await Promise.all(selected.map((node) => deleteNode(lapi, node, bulkJobID)));
    lapi.signal.throwIfAborted();
    const richResults = results.map((result) => ({
      ...result,
      node: nodesById[result.nodeID],
    }));
    lapi.dispatch(removerActions.bulkJobFinished({ bulkJobID, results: richResults }));

    const bulkJobIdAfter = _select(lapi, getBulkJobID);
    if (bulkJobID === bulkJobIdAfter) {
      lapi.dispatch(removerActions.modalClosed());
    }
  });
  lm.takeEvery(removerActions.modalCloseUiEvent, (_, lapi) => {
    lapi.dispatch(removerActions.modalClosed());
  });
  lm.takeEvery(removerActions.bulkJobFinished, (action, lapi) => {
    const failedNodes = action.payload.results.filter(
      ({ success }: { success: boolean }) => !success,
    );
    if (failedNodes.length > 0) {
      const failedNodeNames = failedNodes.map((node: { node: CHNode }) => node.node.name);
      lapi.dispatch(Notifications.error(Messages.removeError(failedNodeNames.join(', '))));
    }
  });
  lm.takeEvery(removerActions.modalOpenedUiEvent, (_, lapi) => {
    const counts = _select(lapi, getSelectedCounts);
    lapi.dispatch(removerActions.modalOpened(counts));
  });
}

async function deleteNode(lapi: ListenerApiLight, node: CHNode, bulkJobID: string) {
  const nodeID = node.id;
  try {
    lapi.dispatch(removerActions.deleteStarted({ nodeID, bulkJobID }));
    const result = await adopted.removerAPI.deleteNode(nodeID);
    lapi.signal.throwIfAborted();
    if (result.status >= 400 && result.status < 500) {
      lapi.dispatch(
        Notifications.error({
          title: 'Failed to delete file',
          message: JSON.stringify((result.response as any).data),
        }),
      );
    }
    logger.lapi(lapi, { action: 'File', sub_action: 'Delete', extra: { int_1: node.id } });
    lapi.dispatch(removerActions.deleteSuccess({ result, nodeID, bulkJobID }));
    return { nodeID, success: true };
  } catch (error) {
    lapi.dispatch(removerActions.deleteError({ error, nodeID, bulkJobID }));
    return { nodeID, success: false };
  }
}
